import { TechServiceAreasToSave } from '../../hooks/useTechServiceAreas';
import { PrimTechServiceAreaLocation } from './types';

export const mapDataToBeSaved = (
  data: PrimTechServiceAreaLocation[],
  original: string[],
): TechServiceAreasToSave => {
  const auxPrimaries = data.map((area) => ({
    ship_to_number: area.ship_to_number,
    secondary_st_locations: area.secondary_st_locations || [],
  }));
  const currentPrimaries = data.map((area) => area.ship_to_number);
  const deletedPrimaries = original.filter(
    (shipTo) => !currentPrimaries.includes(shipTo),
  );
  deletedPrimaries.forEach((shipTo) => {
    auxPrimaries.push({
      ship_to_number: shipTo,
      secondary_st_locations: [],
    });
  });
  const dataToBeSaved: TechServiceAreasToSave = {
    ship_to_list: auxPrimaries,
  };
  return dataToBeSaved;
};

export const mapOnDeleteSTServArea = (st: string): TechServiceAreasToSave => ({
  ship_to_list: [
    {
      ship_to_number: st,
      secondary_st_locations: [],
    },
  ],
});

export const sortServiceAreas = (areas: PrimTechServiceAreaLocation[]) => [...areas].sort((a, b) => {
  if (a.ship_to_number < b.ship_to_number) return -1;
  if (a.ship_to_number > b.ship_to_number) return 1;
  return 0;
});

export const serviceAreasDataMap = (
  areas: PrimTechServiceAreaLocation[],
): { data: PrimTechServiceAreaLocation[]; originales: string[] } => {
  const sortedAreas = sortServiceAreas(areas);
  const originales = sortedAreas.map((area) => area.ship_to_number);
  return { data: sortedAreas, originales };
};
